import React, { useContext } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Hero from "../../components/layout/Hero";
import {
  BCPArrowRightFromBracket,
  BCPSearch,
} from "../../components/icons/bcp/BCPIcons";
import HighlightedEvents from "../../components/utilities/HighlightedEvents";
import FeaturedEvents from "../../components/utilities/FeaturedEvents";
import PostGallery from "../../components/utilities/PostGallery";
import { getEnvironmentVariable } from "../../global/environmentVariables";
const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);

const useStyles = makeStyles((theme) => ({
  hoverOpacImage: {
    height: "120%",
    // maxWidth: "65%",
    opacity: "0.2",
    position: "absolute",
    bottom: "-10%",
    transform: "rotate(-5deg)",
    left: "-125px",
    "@media (max-width: 500px)": {
      left: "-200px",
    },
  },
}));

export default function HomeUnplug() {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  return (
    <>
      <Box sx={{ position: "relative", overflow: "hidden" }}>
        <Hero
          backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/home1.png`}
          sxBackground={{
            height: ["unset", "70vh"],
            maxHeight: ["unset", "600px"],
            // minHeight: "unset",
            color: "common.white",
          }}
        />

        <img
          src={`${SYSTEM_IMAGES_CLOUDFRONT}/images/BannerLogo.png`}
          className={classes.hoverOpacImage}
          alt=""
        />

        <Box
          sx={{
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            "margin-left": "auto",
            "margin-right": "auto",
            color: "#ffffff",
          }}
        >
          <Box
            sx={{
              pt: 8,
              pb: 6,
              height: "100%",
              width: "100%",
              textAlign: "center",
              display: "flex",
              flexFirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Container maxWidth={"sm"} sx={{ p: 1 }}>
              <Typography variant="h1" align="left" color="inherit" paragraph>
                Table Top Adventures, for all skill levels
              </Typography>
              <Box sx={{ marginBottom: 4 }}>
                <Grid container spacing={2} justifyContent="left">
                  <Grid item>
                    <Button
                      href="/play/events"
                      variant="contained"
                      color="primary"
                      startIcon={<BCPSearch />}
                    >
                      Enter Now
                    </Button>
                  </Grid>
                  {!authContext?.authState?.isAuthenticated ? (
                    <Grid item>
                      <Button
                        href="/login"
                        variant="contained"
                        color="secondary"
                        startIcon={<BCPArrowRightFromBracket />}
                      >
                        Login
                      </Button>
                    </Grid>
                  ) : (
                    <Grid item>
                      <Button
                        focusRipple
                        href="/subscription"
                        variant="contained"
                        color="success"
                      >
                        Subscribe
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Container>
          </Box>
        </Box>
      </Box>
      <FeaturedEvents />
      <HighlightedEvents />
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid container spacing={1} sx={{ p: 1, mb: 2 }}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              News
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <PostGallery
              searchLimit={6}
              doPaging={false}
              loadMoreHref="/news"
            />
          </Grid>
        </Grid>
      </Container>

      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/home2.png`}
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          color: "common.white",
        }}
        maxWidth="md"
      >
        <Grid container>
          <Grid item xs={12} md={6} lg={8}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              Level up your experience
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              Stay in the Loop with Tabletop Gaming, News, Events and Releases.
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={4}
            sx={{
              pt: [1, 1, 12],
            }}
          >
            <Box sx={{ marginBottom: 4 }}>
              <Grid
                container
                spacing={2}
                sx={{
                  justifyContent: ["center", "center", "right"],
                }}
              >
                <Grid item xs={12}>
                  <Button
                    focusRipple
                    href="/subscription"
                    variant="contained"
                    color="success"
                  >
                    Subscribe
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Hero>
      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/UYOPS-Players.jpeg`}
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          color: "common.white",
        }}
        maxWidth="md"
      >
        <Grid container>
          <Grid item xs={12} md={6} lg={8}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              Players
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              Level up your game with our Players Subscription. Tailored for
              individual enthusiasts, this plan provides you with the tools and
              resources to enhance your gaming experience.
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={4}
            sx={{
              pt: [1, 1, 12],
            }}
          >
            <Box sx={{ marginBottom: 4 }}>
              <Grid
                container
                spacing={2}
                sx={{
                  justifyContent: ["center", "center", "right"],
                }}
              >
                <Grid item xs={12}>
                  <Button
                    focusRipple
                    href="/subscription"
                    variant="contained"
                    color="success"
                  >
                    Subscribe
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Hero>
      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/UYOPS-Clubs.jpeg`}
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          color: "common.white",
        }}
        maxWidth="md"
      >
        <Grid container>
          <Grid item xs={12} md={6} lg={8}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              Clubs
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              Empower your club with our Clubs Subscription. Perfect for gaming
              groups and clubs, this plan offers advanced tools and resources to
              organize events and foster a thriving community.
            </Typography>
          </Grid>
        </Grid>
      </Hero>
      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/UYOPS-Store.jpeg`}
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          color: "common.white",
        }}
        maxWidth="md"
      >
        <Grid container>
          <Grid item xs={12} md={6} lg={8}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              Stores
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              Boost your business with our Stores Subscription. Designed for
              retail stores, this plan provides extensive features to manage
              events, engage customers, and drive sales.
            </Typography>
          </Grid>
        </Grid>
      </Hero>
    </>
  );
}
